import React from "react";
import { utils } from "../common/utils";
import { useTranslation } from 'react-i18next';
import CurrencyFormat from './CurrencyFormat';

export default function (props) {

    const { t } = useTranslation();

    const { cart, settings, showTitle } = props;
    if (!cart) return <div />;
    let totalQuantityPrice = cart.lines.reduce(function (accumulator, currentLine) {
        return accumulator + (currentLine['quantity'] * currentLine['price']);
    }, 0);

    const totalPrice = totalQuantityPrice + settings.deliveryCharge;

    const title = showTitle ? (<h3 className="widget-title">{t("Order Summary")}</h3>) : "";
    return (
        <section className="widget widget-order-summary">
            {title}
            <table className="table">
                <tbody>
                    <tr>
                        <td>{t("Subtotal")}:</td>
                        <td className="text-medium">
                            <CurrencyFormat value={totalQuantityPrice} settings={settings} />
                            {/*{utils.formatCurrency(totalQuantityPrice)}*/}
                        </td>
                    </tr>
                    <tr>
                        <td>+ {t("Shipping")}:</td>
                        <td className="text-medium">
                            {" "}
                            <CurrencyFormat value={settings.deliveryCharge} settings={settings} />
                            {/*{utils.formatCurrency(settings.deliveryCharge)}*/}
                        </td>
                    </tr>
                    <tr>
                        <td> {t("Total")}:</td>
                        
                        <td className="text-lg text-medium"><CurrencyFormat value={settings.totalPrice} settings={settings} /> {/*{utils.formatCurrency(totalPrice)}*/}</td>
                    </tr>
                </tbody>
            </table>
        </section>
    );
}

